import { z } from 'zod';
import { EMAIL_REGEX } from '@modules/validation/util';
import { CollaboratorAccessEnumSchema } from '@modules/design-board/validation/schemas';

export const emailsValidator = z
    .array(
        z
            .string({ required_error: 'Email is required.' })
            .min(1, { message: 'Email is required' })
            .email({ message: 'Email address is invalid' })
            .regex(EMAIL_REGEX, { message: 'Email address is invalid' })
    )
    .refine(
        (emails) => {
            const uniqueEmails = new Set(emails);
            return uniqueEmails.size === emails.length;
        },
        {
            message: 'Please enter unique emails',
        }
    );

export const validator = z.object({
    emails: emailsValidator,
    message: z.string().optional(),
    access: CollaboratorAccessEnumSchema,
});

export type FormShape = z.infer<typeof validator>;
